import cancellogo from '../Resources/favicons/cancel-50.png';

function InfoBubble ({hideInfo}) {
  return (
    <div className="infobubble-wrapper">
      <div className="infobubble-content">
        <p> 
        Credit to <a href="https://icons8.com/">Icons8</a> and <a href="https://favicon.io/">Favicon</a> for the icons.</p>
        <button onClick={hideInfo} ><img className="ilogo-cancel" src={cancellogo} alt="Close popup"/></button>
      </div>
    </div>
  ) 
}

export default InfoBubble;